<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<no-slider-spacer :class="page.headingImage ? '' : 'no-slider'" />
		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
			:illustration="page.illustration"
		/>

		<section class="main-content rooms-section background-light">
			<div class="row row-header align-center">
				<h2 class="subtitle">{{ defaults[locale].rooms.subtitle }}</h2>
				<h2>{{ defaults[locale].rooms.sectionRoomsTitle }}</h2>
				<div v-parse-links v-html="defaults[locale].rooms.sectionRoomsContent" />
			</div>
			<rooms-overview :items="roomsData">
				<template #extra-content="scope">
					<div class="room-icons">
						<div v-for="facility in scope.facilities" :key="facility.id" class="icon-holder">
							<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
							<span>{{ facility.content }}</span>
						</div>
					</div>
					<nuxt-link :to="scope.filename" class="button button-no-fill">
						{{ defaults[locale].rooms.view }}
					</nuxt-link>
					<book-button class="button cta" :roomid="scope.bookingid">
						{{ defaults[locale].rooms.book }}
					</book-button>
				</template>
			</rooms-overview>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-title="page.sectionContentblocksTitle"
			:content-blocks-subtitle="page.sectionContentblocksSubtitle"
			:illustration="page.sectionContentblocksIllustration"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:formid="defaults[locale].newsletter.mailChimpID"
			:link="defaults[locale].newsletter.mailChimpLink"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: roomsData } = await useWebsiteFetch('rooms', {
	query: { language: locale.value },
	key: `${locale.value}/rooms`,
});
</script>

<style lang="scss" scoped>
.row-header {
	max-width: 1000px;
}

.room-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 40px;
	padding-top: 40px;
}

.icon-holder {
	color: var(--button-nofill-color);
	width: 49%;
	margin: 5px 0;
}

.icon-holder i,
.icon-holder svg {
	margin: 0 5px 0 0;
}

.room-item .room-icons {
	max-width: 600px;
}

.room-info {
	padding: 0 0 50px;

	.row {
		padding: 50px 30px;
	}
}

@media (max-width: 1080px) {
	.icon-holder {
		width: 49%;
	}
}

@media (max-width: 680px) {
	.icon-holder {
		width: 99%;
		margin: 0;
	}
}
</style>
